//@flow
import React from "react";
import InvoiceServerRequest from "../invoice_server_request";
import InvoiceForm from "../components/invoice_form";

type Props = {
  quantity: number,
  schoolName: string,
  disableFields: boolean,
  buttonText: string
};

type State = {
  schoolName: string,
  disableFields: boolean,
  accountingContactEmail: string,
  accountingContactName: string,
  invitationAdministratorEmail: string,
  quantity: number
};

class InvoiceFormContainer extends React.Component<Props, State> {
  state = {
    schoolName: this.props.schoolName,
    quantity: this.props.quantity,
    disableFields: false,
    accountingContactEmail: "",
    accountingContactName: "",
    invitationAdministratorEmail: ""
  };

  handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const input = e.target;

    this.setState({
      [input.name]: input.value
    });
  };

  handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.setState({
      disableFields: true
    });

    InvoiceServerRequest.bind(this)();
  };

  disableFields = () => (this.state.disableFields ? "disabled" : "");

  render() {
    return (
      <InvoiceForm
        disableFields={this.disableFields()}
        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        quantity={this.props.quantity}
        schoolName={this.state.schoolName}
        buttonText={this.props.buttonText}
      />
    );
  }
}

export default InvoiceFormContainer;



// WEBPACK FOOTER //
// ./app/javascript/order_form/containers/invoice_form_container.jsx